import { ApiService } from '../model/Api.model';
import { AxiosInstance } from 'axios';
import { saveByteArray } from 'src/util/saveByteArray';

enum SpecialProjectDocumentServiceEnum {
	downloadSpecialProjectDocumentsZipByIdTrade = '/download-zip-documents/',
}
export default class SpecialProjectDocumentService extends ApiService {
	constructor(restClient: AxiosInstance) {
		super(restClient, '/special-project-document');
	}

	public downloadZipSpecialProjectDocumentsByIdTrade = async (idTrade?: number, user?: string) => {
		const endpoint = SpecialProjectDocumentServiceEnum.downloadSpecialProjectDocumentsZipByIdTrade + idTrade;
		const data = await this.GET(endpoint, 'blob');
		const filename = (idTrade ? `${idTrade}` : '') + (user ? `_${user}` : '') + '.zip';
		saveByteArray(filename, data);
		return data;
	};

}
